import { Grid, GridItem, CheckboxGroupField } from "@certn/cascadia-react";
import { CheckboxGroupItem } from "@certn/cascadia-react/deprecated/inputs/checkbox/Checkbox";
import { usePeopleAPI } from "@certn/legacy-api";
import { slugify } from "@certn/utils";
import { Field } from "formik";
import { useTranslation } from "react-i18next";

import { FormModal } from "../FormModal";

type RequestTypeModalProps = {
  onNext: () => void;
  onClose: () => void;
};

export function RequestTypeModal({ onNext, onClose }: RequestTypeModalProps) {
  const { t } = useTranslation();
  const { data: requestTypes } = usePeopleAPI(
    "/internal/people/request-data-options/"
  );

  return (
    <FormModal
      title={t("Personal data request")}
      onSubmit={onNext}
      onCancel={onClose}
      continueText={t("Next")}
      secondaryText={t("Cancel")}
      variant="success"
    >
      <Grid>
        <GridItem>
          <Field
            as={CheckboxGroupField}
            label={t("Please select the request type")}
            name="request_types"
            isRequired
          >
            {requestTypes?.map(({ value, more_info, description }) => (
              <CheckboxGroupItem
                key={value}
                value={value}
                description={more_info}
                testID={`personal-data-request-modal-${slugify(description)}`}
              >
                {description}
              </CheckboxGroupItem>
            ))}
          </Field>
        </GridItem>
      </Grid>
    </FormModal>
  );
}
